module.exports = __webpack_public_path__ + "img/pinpai-cs.4d74560c.jpg";